import './styles.css';
import { Modal, Paper, Grid, Fab } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ViolinTuner from "../ViolinTuner";

const TuneViolinModal = (props) => {
	const {showTuneViolinModal, handleCloseTuneViolinModal} = props;
	return (
		<Modal
			open={showTuneViolinModal}
		>
			<Paper
	 
	 className="tuneViolinModalPaper"
	 style={{ minHeight: "75vh", minWidth: '80%',  borderRadius: '15px'}}
	//  style={{ minHeight: "75vh", minWidth: '80%',  borderRadius: '15px', backgroundColor: ' #f5f3ef'}}
	 >
				<Grid justifyContent="flex-end" direction="row" container>
					<Fab color="extended" aria-label="refresh" size='small' onClick={handleCloseTuneViolinModal}>
						<CloseIcon />
					</Fab>
				</Grid>
				<ViolinTuner />
			</Paper>
		</Modal>
			
	)
} 

export default TuneViolinModal;